<template>
  <div
    id="home"
    style="z-index: 99;"
  >
    <div
      v-show="deviceInfoBox"
      class="card deviceInfo 4-rah-man"
      :style="{ bottom: deviceInfobottom }"
    >
      <b-card-body style="background: #fff;">
        <div>
          <div
            class="row"
            style="margin-top: 0;padding-left: 0;"
          >
            <div
              class="col-5 col-md-5"
              style="padding: 5px 0px;"
            >
              <v-icon
                size="20"
                color="gray"
              >mdi-chevron-right</v-icon>
              <span style="font-size: 1.1rem;    color: #555;">
                {{ getPopupInfo(selectedDevice).title }}
              </span>
            </div>
            <div
              class="col-2"
              style="padding: 5px 0px;display: flex;bottom: 10px;"
            >
              <v-icon
                v-if="deviceInfobottom==0"
                size="26"
                color="gray"
                style="margin: auto;"
                @click="downdeviceInfo"
              >mdi-chevron-down</v-icon>
              <v-icon
                v-else
                size="26"
                color="gray"
                style="margin: auto;"
                @click="updeviceInfo"
              >mdi-chevron-up</v-icon>
            </div>
            <div
              class="col-5 col-md-5"
              style="text-align: left;padding: 5px 0px;line-height: 1.6rem;"
            >
              <span style="font-size: 0.8rem;">{{ selectedDevice }}</span>
              <v-icon
                size="20"
                color="gray"
              >mdi-chevron-left</v-icon>
            </div>
          </div>
          <div
            class="row"
            :dir="$functions.currentLangDirection()"
            style="height: 65px;"
          >

            <div
              v-if="getPopupInfo(selectedDevice).expire"
              class="col-3"
              style="padding: 2px;text-align: center;"
              @click="onClickMarker(selectedDevice)"
            >
              <span
                  class="expired-bas2"
                style="font-size: 0.7rem;color: #c00;font-weight: bold;"
              >
                {{ $t('Expired') }}

              </span>
              <v-btn
                variant="elevated"
                size="x-small"
                style="background: rgb(45, 158, 46);color: #fff;font-size: 0.7rem;font-weight: bold;padding: 5px 10px !important;height: 28px;margin-bottom: 5px;"
                @click="accountRenew(selectedDevice)"
              >
                {{ $t('Account renew') }}
              </v-btn>
            </div>
            <div
              v-else
              class="col-3"
              style="padding: 2px;text-align: center;"
              @click="onClickMarker(selectedDevice)"
            >
              <span
                v-if="getStatusMovement(selectedDevice)==='offline'"
                style="font-size: 1.5rem;color: gray;"
              >
                {{ $t('Offline') }}
              </span>
              <span
                v-else-if="getStatusMovement(selectedDevice) === 'move'"
                style="font-size: 1.5rem;color: green;"
              >
                {{ $t('Move') }}
              </span>
              <span
                v-else-if="getStatusMovement(selectedDevice) === 'on'"
                style="font-size: 1.5rem;color: #d2a907;"
              >
                {{ $t('On') }}
              </span>
              <span
                v-else
                style="font-size: 1.5rem;color:#e76c6c;"
              >{{ $t('Stop') }}</span>

              <span
                v-if="isNoGpsSignal(selectedDevice)"
                style="font-size: 0.7rem;color: #c00;font-weight: bold;width: 100%;display: block;"
              >
                {{ $t('No GPS signal') }}
              </span>
              <span style="font-size: 0.9rem;    color: #555;width: 100%;display: block;">
                {{ sinceFrom2(getLastAlarm(selectedDevice)) }}
              </span>
            </div>
            <div
              class="col-2"
              style="padding: 2px;text-align: center;"
            >
              <div v-if="checkAccSatatus(selectedDevice)">
                <span style="width: 100%;display: block;">
                  <v-icon
                    size="18"
                    color="#3597ef"
                    style="padding-left: 3px;"
                  >mdi-power-plug</v-icon>
                </span>
                <span>
                  {{ $t('Plugged in') }}
                </span>
              </div>
              <div v-else>
                <span style="width: 100%;display: block;">
                  <v-icon
                    size="18"
                    color="#3597ef"
                    style="padding-left: 3px;"
                  >mdi-power-plug-off</v-icon>
                </span>
                <span>
                  {{ $t('Plugged out') }}
                </span>
              </div>
            </div>
            <div
              class="col-2"
              style="padding: 2px;text-align: center;"
            >
              <span style="width: 100%;display: block;">
                <v-icon
                  size="18"
                  color="#3597ef"
                  style="padding-left: 3px;"
                >mdi-speedometer</v-icon>
              </span>
              <div style="direction: ltr;">
                <span v-if="getStatusMovement(selectedDevice)!=='offline'">
                  {{ getPopupInfo(selectedDevice).serverInfo.speed }}
                </span>
                <span v-else>
                  0
                </span>
                <span style="font-size: 0.7rem;">
                  km/h
                </span>
              </div>
            </div>
            <div
              class="col-2"
              style="padding: 2px;text-align: center;"
            >
              <span style="width: 100%;display: block;">
                <v-icon
                  size="18"
                  color="#3597ef"
                  style="padding-left: 3px;"
                >mdi-satellite-uplink</v-icon>
              </span>
              <span v-if="getStatusMovement(selectedDevice)==='offline'">
                0
              </span>
              <span
                v-else
                style=""
              >
                {{ getPopupInfo(selectedDevice).serverInfo.satCntActive }}
              </span>
            </div>
            <div
              class="col-3"
              style="padding: 2px;text-align: center;"
            >
              <span style="width: 100%;display: block;">
                <v-icon
                  size="18"
                  color="#3597ef"
                  style="padding-left: 3px;"
                >mdi-signal</v-icon>
              </span>
              <span
                v-if="getStatusMovement(selectedDevice)==='offline'"
                style="font-size: 0.6rem;"
              >
                {{ $t('No signal') }}
              </span>
              <span
                v-else
                style="font-size: 0.6rem;"
              >
                {{ getPopupInfo(selectedDevice).serverStatus.gsmSigStrength }}
              </span>
            </div>
          </div>
          <hr>
          <div
            class="row"
            :dir="$functions.currentLangDirection()"
          >
            <div
              class="col-12"
              style="padding: 5px 5px;font-size: 0.8rem;"
            >
              <v-icon
                size="18"
                color="#3597ef"
                style="padding-left: 0px;"
              >mdi-clock-outline</v-icon> {{ $t('Last update') }}:
              <span v-if="getStatusMovement(selectedDevice)==='offline'">
                {{ $t('Offline') }} - بیش از 2 ساعت
              </span>
              <span v-else>
                {{ timeHistory(getPopupInfo(selectedDevice).serverInfo.servertime) }} -
                {{ sinceFromDevice(selectedDevice) }}
              </span>
            </div>
          </div>
          <div
            class="row"
            style="height: 50px;overflow-y: auto;"
            :dir="$functions.currentLangDirection()"
          >
            <div
              class="col-12"
              style="padding: 2px 5px;font-size: 0.8rem;"
            >
              <v-icon
                size="18"
                color="#3597ef"
                style="padding-left: 0px;"
              >mdi-map-marker</v-icon>
              <span
                v-if="address===null"
                style="color: rgb(53, 151, 239);border-bottom: 1px solid;cursor: pointer;"
                @click="getAddress"
              >{{ $t('Show address') }}</span>
              <span
                v-else-if="address==='loading'"
                style="color: #999;"
              >{{ $t('Getting address') }}...</span>
              <span
                v-else-if="address==='error'"
                style="color: #c00;"
              >{{ $t('Address error') }}
                <span
                  style="color: rgb(53, 151, 239);border-bottom: 1px solid;cursor: pointer;margin-right: 5px;"
                  @click="getAddress"
                >{{ $t('Retry') }}</span>
              </span>
              <span v-else>{{ address }}</span>

            </div>
          </div>
          <hr>
          <div
            class="row"
            style=""
          >
            <div
              class="col-3"
              style="padding: 10px 3px;"
            >
              <b-button
                class="btn btn-sm"
                variant="outline-link"
                style="padding: 0px; width: 100%; font-size: 0.8rem; color: #333;"
                @click="clickTracking"
              >
                <span style="width: 100%; display: block;">
                  <v-icon
                    size="25"
                    color="#3597ef"
                  >
                    mdi-history
                  </v-icon>
                </span>
                <span style="width: 100%; display: block;">
                  {{ $t('Tracing') }}
                </span>
              </b-button>
            </div>
            <div
              class="col-3"
              style="padding: 10px 3px;"
            >
              <b-button
                class="btn btn-sm"
                variant="outline-link"
                style="padding: 0px;width: 100%; font-size: 0.8rem; color: #333;"
                @click="clickPlayBack"
              >
                <span style="width: 100%; display: block;">
                  <v-icon
                    size="25"
                    color="#3597ef"
                  >
                    mdi-map-marker-distance
                  </v-icon>
                </span>
                <span style="width: 100%;display: block;">
                  {{ $t('Movement history') }}
                </span>
              </b-button>
            </div>
            <div
              class="col-3"
              style="padding: 10px 3px;"
            >
              <b-button
                class="btn btn-sm"
                variant="outline-link"
                style="padding: 0px;width: 100%;font-size: 0.8rem;color: #333;"
                @click="clickAlarm"
              >
                <span style="width: 100%;display: block;">
                  <v-icon
                    size="25"
                    color="#3597ef"
                  >
                    mdi-alert-outline
                  </v-icon>
                </span>
                <span style="width: 100%;display: block;">
                  {{ $t('Alarms') }}
                </span>
              </b-button>
            </div>
            <div
              class="col-3"
              style="padding: 10px 3px;"
            >
              <b-button
                class="btn btn-sm"
                variant="outline-link"
                style="padding: 0px;width: 100%;font-size: 0.8rem;color: #333;"
                @click="clickDetail"
              >
                <span style="width: 100%;display: block;">
                  <v-icon
                    size="25"
                    color="#3597ef"
                  >
                    mdi-file-document-outline
                  </v-icon>
                </span>
                <span style="width: 100%;display: block;">
                  {{ $t('Details') }}
                </span>
              </b-button>
            </div>
            <div
              class="col-3"
              style="padding: 10px 3px;"
            >
              <b-button
                class="btn btn-sm"
                variant="outline-link"
                style="padding: 0px;width: 100%;font-size: 0.8rem;color: #333;"
                @click="clickCommand"
              >
                <span style="width: 100%;display: block;">
                  <v-icon
                    size="25"
                    color="#3597ef"
                  >
                    mdi-console
                  </v-icon>
                </span>
                <span style="width: 100%;display: block;">
                  {{ $t('Commands') }}
                </span>
              </b-button>
            </div>

            <div
              class="col-3"
              style="padding: 10px 3px;"
            >
              <b-button
                class="btn btn-sm"
                variant="outline-link"
                style="padding: 0px;width: 100%;font-size: 0.8rem;color: #333;"
                @click="clickDashboard"
              >
                <span style="width: 100%;display: block;">
                  <v-icon
                    size="25"
                    color="#3597ef"
                  >
                    mdi-car-speed-limiter
                  </v-icon>
                </span>
                <span style="width: 100%;display: block;">
                  {{ $t('Dashboard') }}
                </span>
              </b-button>
            </div>
            <div
              class="col-3"
              style="padding: 10px 3px;"
            >
              <b-button
                class="btn btn-sm"
                variant="outline-link"
                style="padding: 0px;width: 100%;font-size: 0.8rem;color: #333;"
                @click="onMobileMapShareCarPosition"
              >
                <span style="width: 100%;display: block;">
                  <v-icon
                    size="25"
                    color="#3597ef"
                  >
                    mdi-share-variant-outline
                  </v-icon>
                </span>
                <span style="width: 100%;display: block;">
                  {{ $t('Subscription') }}
                </span>
              </b-button>
            </div>
            <div
              class="col-3"
              style="padding: 10px 3px;"
            >
              <b-button
                class="btn btn-sm"
                variant="outline-link"
                style="padding: 0px;width: 100%;font-size: 0.8rem;color: #333;"
                @click="onSendCommand(selectedDevice, 'updatePosition')"
              >
                <span style="width: 100%;display: block;">
                  <v-icon
                    size="25"
                    color="#3597ef"
                  >
                    mdi-reload
                  </v-icon>
                </span>
                <span style="width: 100%;display: block;">
                  {{ $t('Update') }}
                </span>
              </b-button>
            </div>

          </div>
        </div>

      </b-card-body>
    </div>

    <div
      class="mobileOnMapHint mobileOnMapHintBtns mobileOnMapHintCrosshairBtn"
    >
      <b-button
        variant="gradient-light"
        class="btn-sm "
        style="background: rgb(255, 255, 255) !important;"
        @click="onMobileMapSetMyLocation"
      >

        <v-icon
          size="26"
          color="#6f6f6f"
        >mdi-crosshairs-gps</v-icon>
      </b-button>
    </div>
    <div
      class="mobileOnMapHint mobileOnMapHintBtns mobileOnMapHintRefreshBtn"
    >
      <b-button
        variant="gradient-light"
        class="btn-sm "
        style="background: rgb(255, 255, 255) !important;"
        @click="onClickMarker(selectedDevice)"
      >

        <v-icon
          size="26"
          color="#6f6f6f"
        >mdi-refresh</v-icon>
      </b-button>
    </div>

    <div dir="ltr">
      <l-map
        id="mainMapMob"
        ref="map"
        dir="ltr"
        :zoom="zoom"
        :max-zoom="20"
        :min-zoom="5"
        :center="center"
        :max-bounds="iranBounds"
        :max-bounds-viscosity="1.0"
        :options="{zoomControl: true, preferCanvas: true}"
      >
        <l-control-layers position="bottomleft" />
        <l-tile-layer
          v-for="tileProvider in tileProviders"
          :key="tileProvider.name"
          :name="tileProvider.name"
          :visible="tileProvider.visible"
          :url="tileProvider.url"
          :attribution="tileProvider.attribution"
          :subdomains="tileProvider.subdomains"
          :max-zoom="tileProvider.maxZoom"
          layer-type="base"
          :options="{ maxZoom: 22 }"
        />
        <v-rotated-marker
          v-for="(marker, imei) in mapMarkers"
          :key="imei"
          ref="marker"
          :visible="marker.visible"
          :lat-lng="marker.latlng"
          :rotation-angle="marker.rotationAngle"
          :icon="marker.state === 'myLocation' ? myLocationIcon: marker.state === 'start' ? StartMoveIcon : marker.state === 'end' ? EndMoveIcon : marker.state === 'stop' ? StopMoveIcon : mapCarIcon[imei]"
          @click="onClickMarker(imei)"
        >

          <LTooltip
            v-if="isMobile"
            :options="{
              interactive: false,
              permanent: true,
              opacity: 1,
              direction: 'top',
              offset: [0,-10]
            }"
          >
            <span
              v-if="getStatusMovement(imei)==='offline'"
              style="color:gray;cursor:pointer"
            >{{ getPopupInfo(imei).title }}</span>
            <span
              v-else-if="getStatusMovement(imei) === 'move'"
              style="color:green;cursor:pointer"
            >{{ getPopupInfo(imei).title }}</span>
            <span
              v-else-if="getStatusMovement(imei) === 'on'"
              style="color:#d2a907;cursor:pointer"
            >{{ getPopupInfo(imei).title }}</span>
            <span
              v-else
              style="color:#e76c6c;cursor:pointer"
            >{{ getPopupInfo(imei).title }}</span>
          </LTooltip>

        </v-rotated-marker>
        <l-polyline
          :lat-lngs="polyline.latlngs"
          :color="polyline.color"
        />
      </l-map>
    </div>

    <div
      class="mobileOnMapHint mobileOnTime"
      style="direction: ltr;"
    >
      {{ timerCount }} s
    </div>

    <AlertPopup
        v-if="showNotificationPopup"
        :imei="selectedDevice"
        @close="showNotificationPopup = false"
    />
  </div>

</template>

<script>
import jalalimoment from 'jalali-moment'
import Vue from 'vue'
import {
  BCard, BCardBody, BCardText, BLink, BButton, BFormInput, BButtonGroup, BFormGroup, BFormSelect, BFormSelectOption,
  BProgress, BProgressBar, BForm,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LControlZoom, LPolyline, LPopup, LControlLayers, LTooltip,
} from 'vue2-leaflet'
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker'
import 'leaflet-routing-machine'
import 'leaflet/dist/leaflet.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import PreLoaderSpinner from '@core/components/pre-loader-spinner/PreLoaderSpinner'
import moment from 'moment'
import deviceService from '@/services/device.service'
import router from '@/router'
import Device from '@/models/device'
import Config from '../../../config'
import { getUserData } from '@/auth/utils'
import UserService from '@/services/user.service'
import { i18n } from '@/main'
import AlertPopup from '@/views/AlertPopup.vue'

const LeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [30, 18],
    shadowAnchor: [2, 42],
    popupAnchor: [-3, -20],
    iconSize: [60, 36],
  },
})
const myLeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [18, 18],
    shadowAnchor: [18, 18],
    popupAnchor: [-3, -40],
    iconSize: [36, 36],
  },
})
const PinLeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [23, 70],
    shadowAnchor: [18, 18],
    popupAnchor: [-3, -40],
    iconSize: [46, 75],
  },
})

export default {
  components: {
    AlertPopup,
    BProgress,
    BCard,
    BCardBody,
    BLink,
    BButton,
    LMap,
    LTooltip,
    LTileLayer,
    LPolyline,
    LMarker,
    LPopup,
    LControlZoom,
    LControlLayers,
    datePicker: VuePersianDatetimePicker,
    BForm,
    'v-rotated-marker': Vue2LeafletRotatedMarker,
  },
  data() {
    return {
      showNotificationPopup: true,
      deviceInfobottom: '-129px',
      deviceInfoBox: true,
      search: '',
      desserts: [],
      MobSelectedDevices: {},
      lastAngle: 0,
      timerCount: 10,
      dateHistory: '',
      speedHistory: 0,
      playBackVisible: false,
      PlayStatus: false,
      playTimerPointer: 0,
      playBackValue: 0,
      options: Config.carTypes,
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      timer: null,
      speed: 0,
      address: null,
      count: 0,
      tileProviders: [
        {
          name: 'Map.ir',
          visible: true,
          maxZoom: 22,
          attribution: '© Map.ir',
          url: `${Config.mapir.tileUrl}?x-api-key=${Config.mapir.apiKey}`,
        },
        {
          name: 'OpenStreet',
          visible: false,
          maxZoom: 22,
          attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
      ],
      url: `${Config.mapir.tileUrl}?x-api-key=${Config.mapir.apiKey}`,
      zoom: 17,
      // Iran position
      center: [32.4207, 53.6830],
      iranBounds: [[24.5, 44.0], [40.0, 63.5]],
      mapMarkers: {},
      listLimitDevice: {},
      mapHistoryDateFromFormatted: '',
      mapHistoryTimeStart: '00:00',
      mapHistoryTimeEnd: '23:59',
      mapHistoryTimesSelected: {},
      isMobile: Vue.prototype.$functions.isMobile(),
      selectedDevice: null,
      selectedImei: null,
      lastAlarm: 0,
      tracking: true,
      lastAlarmstatus: 0,
      polyline: {
        latlngs: [],
        color: 'red',
      },
      mapCarIcon: new LeafIcon({
        iconUrl: require('@/assets/images/pins/cars/car.png'),
      }),
      myLocationIcon: new myLeafIcon({
        iconUrl: require('@/assets/images/pins/myloc.png'),
      }),
      StartMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/startmarker-min.png'),
      }),
      EndMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/endmarker-min.png'),
      }),
      StopMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/stopmarker-min.png'),
      }),
      newtitle: '',
      smsconfigtext: 'SERVER,0,s1.4-rah.com,4000,0#',
      items: [
        { title: 'تغییر نام خودرو', icon: 'mdi-account-edit', action: 'modal-change-name' },
        { title: 'تغییر نوع خودرو', icon: 'mdi-car', action: 'modal-change-category' },
        { title: 'تغییر سیمکارت', icon: 'mdi-sim-alert', action: 'modal-change-sim' },
        { title: 'ارسال تنظیمات سرور', icon: 'mdi-apple-keyboard-shift', action: 'modal-send-sms' },
      ],
    }
  },
  watch: {

    timerCount: {
      handler(value) {
        if (value >= 0) {
          setTimeout(() => {
            // eslint-disable-next-line no-plusplus
            this.timerCount--
          }, 1000)
        } else {
          this.timerCount = 10
          this.$forceUpdate()
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },

  },
  created() {
    this.QXUpdateFirebaseData()
    this.$vuetify.rtl = true

    this.showMarkers()
    this.checkOnlineStatus()
    setTimeout(() => {
      // eslint-disable-next-line no-restricted-globals
      history.pushState(
        {},
        null,
        `${this.$route.path}`,
      )
    }, 1000)
  },
  mounted() {
    // محدود کردن نقشه به ایران
    const applyIranBounds = () => {
      if (this.$refs.map && this.$refs.map.mapObject) {
        const map = this.$refs.map.mapObject
        map.setMaxBounds(L.latLngBounds([24.5, 44.0], [40.0, 63.5]))
        map.setMinZoom(5)
        map.options.maxBoundsViscosity = 1.0
      } else {
        setTimeout(applyIranBounds, 500)
      }
    }
    setTimeout(applyIranBounds, 1000)
  },
  methods: {
    accountRenew(imei) {
      const index = Vue.prototype.$functions.getDeviceIndex(imei)
      const item = Vue.prototype.$devices[index]

      const subscribeUrl = `https://4-rah.com/%D8%AA%D9%85%D8%AF%DB%8C%D8%AF-%D8%AD%D8%B3%D8%A7%D8%A8-%DA%A9%D8%A7%D8%B1%D8%A8%D8%B1%DB%8C/?imei=${item.imei}&mobile=${item.userId.mobile}&family=${item.userId.name} ${item.userId.family}`
      if (Vue.prototype.$productionPlatform === 'ios') {
        window.location.href = `http://127.0.0.1:3232/QXNative/?action=launchBrowser-openUrl&url=${encodeURIComponent(subscribeUrl)}`
      } else {
        window.open(subscribeUrl, '_blank', 'noreferrer')
      }
    },
    async addUpdateMarker(marker) {
      const data = marker
      const isVisible = this.isVisibleMarker(data.imei, data.longitude, data.longitude)
      if (typeof data.imei === 'undefined') {
        return
      }
      if (typeof data.imei === 'undefined' || typeof data.latitude === 'undefined' || typeof data.longitude === 'undefined') {
        data.latitude = 0
        data.longitude = 0
        return
      }
      if (data.imei in this.mapMarkers && this.mapMarkers[data.imei]) {
        this.lastAngle = 0
        if (typeof this.mapMarkers[data.imei].latlng !== 'undefined') this.lastAngle = this.calcAngle(this.mapMarkers[data.imei].latlng[0], this.mapMarkers[data.imei].latlng[1], data.latitude, data.longitude) + 90
        if (this.lastAngle === 90) {
          this.lastAngle = this.mapMarkers[data.imei].rotationAngle
        }
      } else {
        this.lastAngle = Math.floor(Math.random() * (180 + 1))
      }

      if (this.selectedDevice === data.imei || data.imei === '123456') {

        if (this.tracking) { this.setMapCenterAndZoom([data.latitude, data.longitude], null) }
      }
      this.speed = data.speed
      if (data.speed === '' || data.speed == null) this.speed = 0

      if (data.imei === '123456') {
        this.mapMarkers[data.imei] = {
          visible: true,
          latlng: [data.latitude, data.longitude],
          rotationAngle: this.lastAngle,
          state: 'myLocation',
        }
      } else if (isVisible) {
        this.mapMarkers[data.imei] = {
          visible: isVisible,
          latlng: [data.latitude, data.longitude],
          rotationAngle: this.lastAngle,
        }
      }

      // this.$forceUpdate()
    },
    // eslint-disable-next-line consistent-return
    addMarker(imei) {
      const index = Vue.prototype.$functions.getDeviceIndex(imei)
      if (index === -1 || !Vue.prototype.$devices[index] || !Vue.prototype.$devices[index].serverInfo) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('Error'),
            text: 'موقعیت دستگاه موجود نمی باشد.',
            icon: 'XIcon',
            variant: 'danger',
            dir: Vue.prototype.$functions.currentLangDirection(),
          },
        })
        return null
      }
      let latitude
      let longitude
      const { serverInfo } = Vue.prototype.$devices[index]
      if (typeof serverInfo.lat !== 'undefined' && serverInfo.lat !== null) {
        latitude = serverInfo.lat
        longitude = serverInfo.lon
      } else if (typeof serverInfo.latitude !== 'undefined' && serverInfo.latitude !== null) {
        // Check if latitude is an object with $numberDecimal or a direct value
        if (typeof serverInfo.latitude === 'object' && serverInfo.latitude.$numberDecimal) {
          latitude = serverInfo.latitude.$numberDecimal
          longitude = serverInfo.longitude.$numberDecimal
        } else {
          latitude = serverInfo.latitude
          longitude = serverInfo.longitude
        }
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('Error'),
            text: 'موقعیت دستگاه موجود نمی باشد.',
            icon: 'XIcon',
            variant: 'danger',
            dir: Vue.prototype.$functions.currentLangDirection(),
          },
        })
        return null
      }
      // Validate coordinates are valid numbers
      if (!latitude || !longitude || latitude === 0 || longitude === 0) {
        return null
      }
      const data = {
        latitude,
        longitude,
        imei,
      }
      this.mapMarkers[data.imei] = {
        // علاوه بر اینکه باید برای نمایش انتخاب شده باشد اگر
        // مقادیر مختصاتی نا معتبر داشته باشد هم نباید نمایش داده شود زیرا
        // نقطه نمایش پرت خواهد بود و نامرتبط
        visible: true,
        latlng: [latitude, longitude],
        rotationAngle: this.lastAngle,
      }
      this.MobSelectedDevices[data.imei] = true
      Vue.prototype.$functions.setImeiForSocket(this.MobSelectedDevices)
      this.addUpdateMarker(data)
    },
    onClickMarker(val) {
      this.tracking = true
      this.address = null
      this.selectedDevice = val
      Vue.prototype.$selectDashboard = val
      this.lastAlarmstatus = 0
      Vue.prototype.$functions.setMobileSelectedDevices([this.selectedDevice])
      // this.getLastAlarm(this.selectedDevice)
      this.addMarker(val)
      /*
      Object.keys(this.mapMarkers).forEach(imei => {
        if (this.selectedDevice === imei) {
          this.mapMarkers[imei].visible = true
        }
      })

       */
      const deviceInfo = this.getPopupInfo(this.selectedDevice)
      if (!deviceInfo || !deviceInfo.serverInfo) return
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
      if (!coords) return
      this.setMapCenterAndZoom([coords.lat, coords.lng], 16)
      // this.$forceUpdate()
    },

    showMarkers() {
      // کاربر قبلا لاگین کرده و مستقیم وارد این صفحه می شود
      // در نتیجه لیست دستگاه ها باید گرفته شود
      Vue.prototype.$functions.fillDevices().then(() => {
        for (let i = 0; i <= Vue.prototype.$devices.length - 1; i++) {
          Vue.prototype.$devices[i] = this.getFixDeviceInfo(Vue.prototype.$devices[i])
          if (i < Vue.prototype.$functions.getMapLimit()) {
            this.listLimitDevice[i] = Vue.prototype.$devices[i].imei
          }

          if (this.selectedDevice === null) {
            Vue.prototype.$selectDashboard = this.listLimitDevice[i]
            this.selectedDevice = this.listLimitDevice[i]
            Vue.prototype.$functions.setMobileSelectedDevices([this.listLimitDevice[i]])
          }
          ///
          const device = Vue.prototype.$devices[i]

          if (typeof device.serverInfo === 'undefined') {
            // eslint-disable-next-line no-continue
            device.serverInfo = {}
          }

          // استفاده از helper برای استخراج امن مختصات
          const coords = Vue.prototype.$functions.getLatLngFromServerInfo(device.serverInfo)
          if (!coords) {
            // eslint-disable-next-line no-continue
            continue
          }

          const data = {
            latitude: coords.lat,
            longitude: coords.lng,
            imei: device.imei,
          }
          const deviceInfo = Vue.prototype.$functions.getDeviceInfo(data.imei)
          if (typeof this.options[deviceInfo.category] === 'undefined') {
            deviceInfo.category = 0
          }
          // eslint-disable-next-line new-cap
          this.mapCarIcon[device.imei] = new LeafIcon({
            // eslint-disable-next-line global-require,import/no-dynamic-require
            iconUrl: require(`@/assets/images/pins/cars/${this.options[deviceInfo.category].src}.png`),
          })
          this.addUpdateMarker(data)
        }
        // this.onClickMarker(this.selectedDevice)
      })
      // this.$forceUpdate()
    },
    // eslint-disable-next-line consistent-return
    checkAccSatatus(imei) {
      const popupInfo = this.getPopupInfo(imei)
      // بررسی وجود اطلاعات
      if (!popupInfo || !popupInfo.serverStatus || !popupInfo.serverStatus.terminalInfo) {
        return false
      }
      const { gpsTrackingChangeTime = 0, ignitionChangeTime = 0, ignition = false } = popupInfo.serverStatus.terminalInfo
      if (ignition) return true
      if (gpsTrackingChangeTime === 0) return false
      if (Math.abs(gpsTrackingChangeTime - ignitionChangeTime) < 600) return true
      return false
    },
    onSendCommand(imei, commandName) {
      deviceService.sendCommand({
        imei,
        commandName,
      }).then(
        res => {
          if (res.status === 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('Message'),
                text: 'درخواست بروزرسانی به دستگاه ارسال شد.',
                icon: 'XIcon',
                variant: 'success',
              },
            })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
              dir: Vue.prototype.$functions.currentLangDirection(),
            },
          })
        },
      )
    },
    QXUpdateFirebaseData() {
      UserService.updateFirebaseDataIfNeeded({})
    },
    onShowInMap(val) {
      this.deviceInfobottom = '-129px'
      this.lastAlarmstatus = 0
      this.lastAlarm = 0
      this.onClickMarker(val)
    },
    clickDetail() {
      Vue.prototype.$selectDeviceDetail = this.selectedDevice
      this.$emit('on-change-page', 'detail', this.selectedDevice)
    },
    clickDashboard() {
      Vue.prototype.$selectDashboard = this.selectedDevice
      this.$emit('on-change-page', 'dashboard', this.selectedDevice)
    },
    clickCommand() {
      Vue.prototype.$selectCommand = this.selectedDevice
      this.$emit('on-change-page', 'command', this.selectedDevice)
    },
    clickAlarm() {
      this.$emit('on-change-page', 'alertList', this.selectedDevice)
    },
    clickPlayBack() {
      Vue.prototype.$selectDevicePlayBack = this.selectedDevice
      this.$emit('on-change-page', 'playback', this.selectedDevice)
    },
    clickTracking() {
      Vue.prototype.$selectDeviceTracking = this.selectedDevice
      this.$emit('on-change-page', 'tracking', this.selectedDevice)
    },
    downdeviceInfo() {
      this.deviceInfobottom = '-129px'
    },
    updeviceInfo() {
      this.deviceInfobottom = 0
    },
    getLastAlarm(imei) {
      const popupInfo = this.getPopupInfo(imei)
      // بررسی وجود اطلاعات
      if (!popupInfo || !popupInfo.serverStatus || !popupInfo.serverStatus.terminalInfo) {
        return 0
      }
      const { gpsTrackingChangeTime = 0, ignitionChangeTime = 0 } = popupInfo.serverStatus.terminalInfo
      const lastStatus = Vue.prototype.$functions.getStatusMovement(imei)
      if (ignitionChangeTime === 0) {
        if (gpsTrackingChangeTime !== 0) {
          return gpsTrackingChangeTime
        }
      }
      if (lastStatus === 'offline' || lastStatus === 'stop') {
        if (gpsTrackingChangeTime > ignitionChangeTime) return gpsTrackingChangeTime
        return ignitionChangeTime
      }
      return ignitionChangeTime
    },
    getFixDeviceInfo(device) {
      return Vue.prototype.$functions.fixDeviceInfo(device)
    },
    getDeviceOnlineStatusCssClass(imei) {
      try {
        return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].onlineStatus
      } catch (e) {
        return false
      }
    },
    calcAngle(cx, cy, ex, ey) {
      const dy = ey - cy
      const dx = ex - cx
      // range (-PI, PI]
      let theta = Math.atan2(dy, dx)
      // rads to degs, range (-180, 180]
      theta *= 180 / Math.PI
      // if (theta < 0) theta = 360 + theta; // range [0, 360)
      return theta
    },
    getMyLocation() {
      // eslint-disable-next-line no-unused-vars
      const handleOrientationEvent = function (frontToBack, leftToRight, rotateDegrees) {
      }
      if (window.DeviceOrientationEvent) {
        window.addEventListener('deviceorientation', event => {
          // alpha: rotation around z-axis
          const rotateDegrees = event.alpha
          // gamma: left to right
          const leftToRight = event.gamma
          // beta: front back motion
          const frontToBack = event.beta

          handleOrientationEvent(frontToBack, leftToRight, rotateDegrees)
        }, true)
      }

      // additionally, supplying options for fine-tuning, if you want to
      const options = {
        enableHighAccuracy: true,
        // time in millis when error callback will be invoked
        timeout: 5000,
        // max cached age of gps data, also in millis
        maximumAge: 0,
      }
      return new Promise(((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          pos => {
            resolve(pos)
          },
          err => {
            reject(err)
          },
          options,
        )
      }))
    },
    onMobileMapShareCarPosition() {
      if (this.selectedDevice.length <= 0) {
        return
      }
      const deviceInfo = this.getPopupInfo(this.selectedDevice)
      if (!deviceInfo || !deviceInfo.serverInfo) return
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
      if (!coords) return

      const sh = `https://www.google.com/maps/search/?api=1&query=${coords.lat},${coords.lng}`
      if (Vue.prototype.$productionPlatform === 'ios') {
        window.location.href = `http://127.0.0.1:3232/QXNative/?action=launchBrowser-openUrl&url=${encodeURIComponent(sh)}`
      } else if (navigator.share) {
        navigator.share({
          title: 'چهارراه',
          text: 'موقعیت خودرو من',
          url: sh,
        }).then(() => console.log('Successful shared.'))
          .catch(error => console.log('Error sharing: ', error))
      } else {
        window.open(
          sh,
          '_blank', // <- This is what makes it open in a new window.
        )
      }
      // window.location.href = `geo:${parseFloat(deviceInfo.serverInfo.latitude.$numberDecimal)},${parseFloat(deviceInfo.serverInfo.longitude.$numberDecimal)}`
    },
    async onMobileMapSetMyLocation() {
      this.tracking = false
      const position = await this.getMyLocation()
      // const position = {coords:{latitude:33,longitude:55}}

      if ('coords' in position) {
        const data = {
          imei: '123456', state: 'myLocation', latitude: position.coords.latitude, longitude: position.coords.longitude,
        }
        this.addUpdateMarker(data)
        this.setMapCenterAndZoom([data.latitude, data.longitude], 15)
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'پیام',
            text: 'دسترسی به موقعیت مکانی شما ممکن نیست.',
            icon: 'XIcon',
            variant: 'warning',
          },
        })
      }
    },
    timeHistory(unixTime) {
      // بررسی مقادیر نامعتبر
      if (!unixTime || unixTime < 1000) return ''
      if (this.$t('lang') === 'fa') {
        return Vue.prototype.$functions.toFaNumbers(this.$functions.unixToPersianDate(unixTime))
      }
      return moment.unix(unixTime).format('DD-MM-YYYY HH:mm:ss')
    },
    sinceFrom(unixTime) {
      if (!unixTime || unixTime < 1000) {
        return this.$t('Unknown')
      }
      const time = Vue.prototype.$functions.time()
      return this.$functions.timeSince(unixTime > time ? time : unixTime)
    },
    sinceFromDevice(imei) {
      const d = Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(imei))
      if (!d || !d.serverInfo) return this.$t('Unknown')
      const servertime = d.serverInfo.servertime || 0
      const statusServertime = d.serverStatus?.servertime || 0
      const lastContact = Math.max(servertime, statusServertime)
      if (!lastContact || lastContact < 1000) return this.$t('Unknown')
      return this.sinceFrom(lastContact)
    },
    sinceFrom2(unixTime) {
      if (!unixTime || unixTime < 1000) {
        return ''
      }
      const time = Vue.prototype.$functions.time()

      return this.$functions.timeSince(unixTime > time ? time : unixTime).replace(' پیش', '').replace(' اکنون', '')
    },
    checkOnlineStatus() {
      clearInterval(Vue.prototype.$timer)
      Vue.prototype.$timer = setInterval(() => {
        this.$socket.emit('devicesOnlineTime', {})
      }, 20000)
    },
    getMarkerImei(index) {
      if (this.isMobile && this.selectedImei) {
        return this.selectedImei
      }
      return index
    },

    async getAddress() {
      const deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.selectedDevice)
      if (!deviceInfo || !deviceInfo.serverInfo) return
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
      if (!coords) return
      this.address = 'loading'
      try {
        const result = await Vue.prototype.$functions.getFullAddress({
          latitude: coords.lat,
          longitude: coords.lng,
        }, this.selectedDevice)
        this.address = result || 'error'
      } catch (e) {
        this.address = 'error'
      }
    },
    isNoGpsSignal(imei) {
      if (typeof imei === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.isNoGpsSignal(imei)
    },
    getStatusMovement(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.getStatusMovement(index)
    },
    getPopupInfo(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(this.getMarkerImei(index)))
    },
    async setMapCenterAndZoom(center, zoom) {
      if (this.$refs.map) {
        if (zoom && zoom !== null) {
          await this.$refs.map.setZoom(zoom)
        }
        if (center) {
          const rf = this.$refs.map
          setTimeout(() => {
            rf.setCenter(center)
          }, 1000)
        }
      }
    },
    isVisibleMarker(imei, lat, lon) {
      if (lat < 0 || lon < 0) {
        return false
      }
      if (this.selectedDevice === imei) {
        return true
      }
      let find = false
      const i = 0
      Object.keys(this.listLimitDevice)
        .forEach(keyIsImei => {
          if (this.listLimitDevice[keyIsImei] === imei) {
            find = true
          }
        })
      if (find) return true
      return false
    },
  },
  sockets: {
    devicesOnlineTime(imeis) {
      for (const imei in imeis) {
        const index = Vue.prototype.$functions.getDeviceIndex(imei)
        if (Vue.prototype.$devices[index] !== undefined) {
          if (!Vue.prototype.$devices[index].expire) {
            const diff = this.$functions.time() - imeis[imei]
            if (diff > 2 * 60 * 60) { // 2 ساعت - برای آفلاین واقعی
              Vue.prototype.$devices[index].onlineStatus = 'offlineSymbol'
            } else {
              Vue.prototype.$devices[index].onlineStatus = 'onlineSymbol'
            }
            // serverInfo.servertime را از devicesOnlineTime آپدیت نمی‌کنیم
            // چون مقدار آن با آخرین position واقعی فرق دارد
          }
        }
      }
      // this.$root.$emit('forceUpdate', { event: 'socket.devicesOnlineTime', data: imeis })
      this.$forceUpdate()
    },
    deviceStatus(data) {
      // terminalInfo.gpsTracking
      if ('imei' in data) {
        const index = Vue.prototype.$functions.getDeviceIndex(data.imei)
        if (index >= 0) {
          if (Vue.prototype.$devices[index] !== undefined) {
            if (!Vue.prototype.$devices[index].expire) {
              Vue.prototype.$devices[index].serverStatus = data
              // دریافت هر پکت وضعیت یعنی دستگاه زنده است؛ چراغ آنلاین را همین‌جا تازه کن
              Vue.prototype.$devices[index].onlineStatus = 'onlineSymbol'
              //   this.$root.$emit('forceUpdate', { event: 'socket.deviceStatus', data })
              this.$forceUpdate()
            }
          }
        }
      }
    },
    devicePosition(data) {
      // برای غیر موبایل همیشه true هست و برای حالت موبایل
      // بررسی می شود که در صورت وجود در لیست نمایش دهد
      const index = Vue.prototype.$functions.getDeviceIndex(data.imei)
      if (index >= 0) {
        if (Vue.prototype.$devices[index] !== undefined) {
          if (!Vue.prototype.$devices[index].expire) {
            Vue.prototype.$devices[index].serverInfo = data
            // دریافت موقعیت هم یعنی دستگاه زنده است؛ چراغ آنلاین را تازه کن
            Vue.prototype.$devices[index].onlineStatus = 'onlineSymbol'
            //  Vue.prototype.$devices[index].serverInfo.satCnt = data.satCnt
            //   Vue.prototype.$devices[index].serverInfo.satCntActive = data.satCntActive

            if ('imei' in data) {
              // برای غیر موبایل همیشه true هست و برای حالت موبایل
              // بررسی می شود که در صورت وجود در لیست نمایش دهد
              //  if (Vue.prototype.$functions.checkImeiInSelectedList(payload.data.imei)) {
              this.addUpdateMarker(data)
              if (data.imei === this.selectedDevice) {
                this.$forceUpdate()
              }

              //  }
            }
          }
        }
      }
    },
    /*
    deviceReport(data) {
      // if (this.selectedDevice === data.imei){
      this.reportLog += `\n${JSON.stringify(data)}`

      const el = this.$refs.mytextarea
      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollTop = el.scrollHeight
      }
      // }
        // console.log("datadatadatadatadatadatadata")
        // console.log(data)
        // console.log(this.selectedDevice)
        // console.log(data.event.string)


    },*/
  },
}
</script>

<style>
[dir=ltr] {
  direction: ltr;
  text-align: left;
}

[dir=rtl] * {
  font-family: Vazir;
}

[dir=rtl] .leaflet-zoom-animated {
  transform-origin:   0% 0% !important;
  -webkit-transform-origin:   0% 0% !important;
  -ms-transform-origin:   0% 0% !important;
}

[dir=rtl] .leaflet-marker-icon {
  transform-origin: center center 0px !important;
}

[dir=rtl] .leaflet-pane, [dir=rtl] .leaflet-tile, [dir=rtl] .leaflet-marker-icon,
[dir=rtl] .leaflet-marker-shadow, [dir=rtl] .leaflet-tile-container, [dir=rtl] .leaflet-pane > svg,
[dir=rtl] .leaflet-pane > canvas, [dir=rtl] .leaflet-zoom-box, [dir=rtl] .leaflet-image-layer, [dir=rtl]
.leaflet-layer {
  right: unset !important;
}

.nodiplay .content-header{
  display: none !important;
}
.nodiplay .content-body{
  margin: -47px -27px !important;
}

[dir=rtl] #mainMapMob {
  width: calc( 100vw - 400px );
  height: calc( 100vh - 60px );
  direction: ltr !important;
  text-align: left !important;
  padding: 0 !important;
  margin: 0 !important;
  top: 49px !important;
  right: 400px !important;
  position: absolute;
}

#home .deviceRow {
  margin-bottom: 4px;
  width: 100%;
  padding: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 7px;
}

#home .deviceRow:hover {
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}

.deviceInfo .card-body {
  padding-top: 8px !important;
}
#home .card-body {
  padding-top: 0;
  /*
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
  */

}

.vpd-input-group input {
  border-radius: 0;
  text-align: center;
}

.vpd-input-group label {
  margin-bottom: 0 !important;
}

[dir=rtl] .deviceInfo{
  z-index: 998;
  width: 400px;
  overflow-y: hidden;
  position: absolute;
  border-radius: 0;
  background: #f7f7f7;
  box-shadow: 0 0 15px rgba(0,0,0,0.55);
  clip-path: inset(0px -15px 0px 0px);
}
.deviceRow {
  background: #fff;
}

.collapse .card-body{
  padding-left: 0.3rem !important;
  padding-right: 0.3rem !important;
}
@media (max-width: 767px) {
  [dir=rtl] #mainMapMob {
    width: 100vw;
    height: calc( 100% - 240px );
    direction: ltr !important;
    text-align: left !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
    position: absolute;

    right: inherit  !important;
    left: 0 !important;
  }
 [dir="rtl"] .deviceInfo{
    width: 100%;
  }
  [dir="rtl"] .deviceInfo {
    background: #eee;
    height: 340px !important;
    right: 0;
  }

  .leaflet-bottom{
    bottom: unset !important;
    top: 40px;
  }
  .leaflet-control-zoom{
    top: 70px;
  }
  .leaflet-control-zoom a{
    color: gray;
  }
  [dir="rtl"] #home .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
    height: 70px !important;;
  }
}

.onlineSymbol, .offlineSymbol {
  height: 6px;
  width: 6px;
  border-radius: 50%;
  display: inline-block;
}

.onlineSymbol {
  background-color: #39e340;
}

.offlineSymbol {
  background-color: #b5b5b5;
}

.mobileOnMapHint {
  position: absolute;
  z-index: 999;
  background: rgba(70, 72, 72, 0.67);
  opacity: 0.9;
  border-radius: 5px;
  padding: 3px 6px 3px 6px;
  color: white;
  font-size: 1rem;
}

.mobileOnMapHintBtns {
  background: none;
}

.mobileOnMapHint button {
  height: 32px;
  width: 32px;
  padding: 0;
  font-size: 1.1rem;
  background: rgb(72, 128, 147) !important;
}

.mobileOnMapHistoryBtn {
  border-radius: 3px;
  padding: 0;
  opacity: 0.8;
  background: unset;
  right: 10px;
  bottom: 50px
}

.mobileOnMapHistoryBtn button {
  text-align: center;
  color: #eee;
  background: #5113db;
}

[dir=rtl] .mobileOnMapHintCrosshairBtn {
  top: 32px;
  left: 5px;
  background: #fff;
  padding: 0px;
  border: 2px solid #d0cfcf;
}
[dir=rtl] .mobileOnMapHintRefreshBtn {
  top: 72px;
  left: 5px;
  background: #fff;
  padding: 0px !important;
  border: 2px solid #d0cfcf;
}

[dir=rtl] #home .addDeviceBtn {
  height: 37px;
  width: 38px;
  z-index: 999;
  padding: 0
}
[dir] .btn-secondary:active{
  background-color: unset !important;
}
[dir=rtl] .playBtn {
  cursor: pointer;
  background: #ea121200 !important;
  border: 0px !important;
  top: 10px;
  left: 15px;
  z-index: 999;
  padding: 0
}
[dir=rtl] .closeBtn {
  height: 25px;
  width: 25px;
  position: absolute;
  right: 10px;
  top: 8px;
  z-index: 999;
  padding: 0
}

.leaflet-control-attribution {
  display: none;
}

.vpd-wrapper {
  z-index: 999 !important;
}
.rounded-circle{
  color: #fff !important;
}

[dir="rtl"] .v-input--selection-controls__ripple{

}
.v-menu{
  display: block !important;
}

.v-menu__content {
  font-size: 12px !important;
  opacity: 1 !important;
  background: #fff !important;
  box-shadow: 0 3px 14px rgba(0,0,0,0.4);
}

[dir] .leaflet-tooltip{
  padding: 1px 3px !important;
  border-radius: 8px;
}
.Vue-Toastification__container{
  z-index: 99999;
}

[dir=rtl] .mobileOnTime {
  top: 35px;
  left: 60px;
}
</style>
